(function () {
    'use strict';

    angular.module('app')
        .factory('Museo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "museo";
        return ResourceHelper.getResource(entidad, {}, {
            findPublic: {
                method: 'GET',
                url:
                'api/' + entidad + '/findPublic'
            },
            getByUrl: {
                method: 'GET',
                url: 'api/' + entidad + '/getByUrl',
                params: {
                    url: null
                }
            },
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            }
        });
    }

})();
